module.exports = __webpack_public_path__ + "static/img/blog-comment-two.453f7c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/blog-comment-two.jpg
// module id = P7ej
// module chunks = 0